<template>
  <aw-drag
    class="LeftNav__Item xl:list-item hidden"
    :class="{
      opened: opened[item.url],
      'LeftNav__Item--active': activeCurrent[item.url],
      'LeftNav__ItemPlaceholder': item.placeholder,
      'LeftNav__ItemFolder': item.type === 'folder',
    }"
    :drag-item="item" 
    :drag-start-timeout="300" 
    :origin-drop-area-id="originDropAreaId"
    tag="li"
    #default="{ dragHandle, dragEl }"
    :enable="dragEnabled"
  >
    <span
      class="LeftNav__ItemWrapper flex items-center text-sm cursor-pointer"
      @click="handleClick()"
      :ref="(el) => { dragHandle(el); dragEl(el) }"
    >
      <span 
        class="mr-2" 
        @click.stop.prevent="toggleIcon()"
      >
        <aw-icon
          v-if="toggleLoading"
          icon="loading"
          class="animate-spin w-4 h-4 "
        />
        <aw-icon
          v-else-if="icon || item.children"
          :icon="
            item.children
              ? opened[item.url]
                ? folderOpenedIcon
                : folderIcon
              : icon
          "
          class="w-4 h-4 "
        />
        <span v-else class="w-4 mr-4 xl:mr-0"></span>
      </span>
      <span class="name">{{ truncate(item.name) }}</span>
    </span>
    <bc-tree
      v-if="item.type === 'folder' && opened[item.url]"
      :items="item.children"
      item-key="url"
      v-model="opened"
      v-slot="slotProps"
      class="recursive"
      :drop-area-id="'bc-tree-' + item.id"
      :parent-bc-folder-id="item.id"
      :can-drop="item.can_edit && bcFolderStore.show == 'bc' && bcFolderStore.order == 'rank'"
    >
      <folders-left-nav-item
        v-model="opened"
        :toggle="slotProps.toggle"
        :open="slotProps.open"
        :item="slotProps.item"
        :active-current="activeCurrent"
        :icon="icon"
        :folder-icon="slotProps.item.link ? 'link' : 'folder'"
        :folder-opened-icon="folderOpenedIcon"
        :origin-drop-area-id="slotProps.dropAreaId"
        :key="slotProps.item.url"
      />
    </bc-tree>
  </aw-drag>
</template>

<script>
import { mapStores } from 'pinia'
import useBcFolderStore from '@/frontapp/store/bcFolder'
import useBcSearchStore from '@/frontapp/store/bcSearch'
import truncate from 'lodash/truncate'
import AwDnd from '../DragAndDrop/AwDnd'

export default {
  name: 'FoldersLeftNavItem',
  emits: ['update:modelValue'],
  props: [
    'item',
    'toggle',
    'modelValue',
    'activeCurrent',
    'icon',
    'folderIcon',
    'folderOpenedIcon',
    'stLevel',
    'open',
    'originDropAreaId'
  ],
  data() {
    return {
      toggleLoading: false,
      dropOnHoverTimeout: null,
    }
  },
  methods: {
    truncate(s, l = 50) {
      return truncate(s, { length: l })
    },
    async loadFolder() {
      if (this.stLevel && this.item.type === 'folder') {
        this.toggleLoading = true
        await this.bcFolderStore.loadFolder(this.item.id)
        this.toggleLoading = false
      }
    },
    async toggleIcon() {
      await this.loadFolder()
      this.toggle(this.item.url)
    },
    handleClick() {
      this.bcSearchStore.cancel()

      if (this.item.link) {
        const routeData = this.$router.resolve(this.item.link)
        window.open(routeData.href, '_blank')
      } else {
        const path = new URL(this.item.url).pathname
        this.$router.push(path)
      }
    }
  },
  computed: {
    ...mapStores( useBcFolderStore, useBcSearchStore),
    opened: {
      get() {
        return this.modelValue
      },
      set(val) {
        this.$emit('update:modelValue', val)
      }
    },
    overElementId() {
      return AwDnd.overElementId.value
    },
    dragEnabled() {
      return this.item.can_edit
        && this.bcFolderStore.order === 'rank'
        && this.bcFolderStore.show === 'bc'
        && this.bcFolderStore.trashBin === false
    }
  },
  watch: {
    async overElementId(newVal) {
      let dropOnHoverTimeout = null

      if (this.item.type === 'document' || newVal !== this.item.id || AwDnd.draggedItem.value.id === newVal || !AwDnd.draggedElement.classList.contains('LeftNav__Item')) {
        clearTimeout(dropOnHoverTimeout)
        dropOnHoverTimeout = null
        return
      }

      dropOnHoverTimeout = setTimeout(async () => {
        if (this.overElementId === this.item?.id && this.item?.type === 'folder' && AwDnd.draggedItem?.value?.id !== newVal && AwDnd.draggedElement?.classList.contains('LeftNav__Item')) {
          await this.loadFolder()
          this.open(this.item.url)
        }
      }, 1000)
    }
  }
}
</script>
